import React, {useState} from "react"
import LinkDevice from "./LinkDevice"
import ProfileComplete from "./ProfileComplete";
import ProfileWizardHeader from "../Headers/ProfileWizardHeader";
import AgreeTermsAndPrivacy from "./AgreeTermsAndPrivacy";

function ProfileWizard(props: { cognitoUser: object, realvrUser: object, getRealvrUser: any }) {
  const {cognitoUser, realvrUser, getRealvrUser} = props;
  const [step, setStep] = useState(1)
  const maxSteps = 3;

  function nextFn(): void {
    if (step < maxSteps) {
      setStep((prev) => prev + 1)
    } else {
      getRealvrUser();
    }
  }

  return (
    <>
      <ProfileWizardHeader cognitoUser={cognitoUser} step={step} maxSteps={maxSteps}/>
      <AgreeTermsAndPrivacy step={step} nextFn={nextFn} realvrUser={realvrUser}/>
      <LinkDevice step={step} nextFn={nextFn}/>
      <ProfileComplete step={step} getRealvrUser={getRealvrUser}/>
    </>
  )
}

export default ProfileWizard;
